module.exports = __webpack_public_path__ + "img/logo_circular_bco.f0863a9e.png";